<app-modal title="Select recipients" #modalComponent>
  <form (ngSubmit)="onSubmit()" #f="ngForm" class="p-3" autocomplete="off">

    <div class="mb-3 row">
      <label for="recipients" class="col-sm-3 col-form-label">Recipients:</label>
      <div class="col-sm-9">
       <textarea class="form-control"
                 name="recipients"
                 id="recipients"
                 [ngModel]="recipientsString()"
                 (ngModelChange)="recipientsString.set($event)"
                 placeholder="Recipients separated with commas">
       </textarea>
      </div>
    </div>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!f.valid || !recipientsString() || loading()">Send
      </button>
    </div>
  </form>
</app-modal>